import AscendingK from '../components/AscendingK';
import { Icons } from '../components/Icons';
import { getPublicCardUrl } from '../lib/site';
import { getPocQrPageUrl } from '../lib/poc-qr';
import { nameToSlug } from '../utils/validation';

export default function CardPage({ user }) {
  const slug = user.slug || nameToSlug(user.name);
  const publicCardUrl = getPublicCardUrl(slug);
  const qrFrameUrl = user.photo
    ? getPocQrPageUrl({ photoUrl: user.photo, targetUrl: publicCardUrl })
    : '';
  const qrPageUrl = user.photo
    ? getPocQrPageUrl({ photoUrl: user.photo, targetUrl: publicCardUrl, embed: false })
    : '';

  return (
    <>
      <div className="page-header">
        <div className="mono" style={{ marginBottom: 8 }}>Your Card</div>
        <h1 className="page-title">
          Share your <em>card</em>.
        </h1>
        <p className="page-subtitle">Show this QR code to anyone - they&apos;ll land on your scan page.</p>
      </div>

      <div className="page-body">
        <div className="qr-card-container animate-fadeUp">
          <div className="qr-card-header">
            <div>
              <div className="qr-card-name">{user.name}</div>
              <div className="qr-card-role">
                {user.title}
                {user.company ? ` - ${user.company}` : ''}
              </div>
            </div>
            <AscendingK size={20} color="#C9A961" />
          </div>

          <div className="qr-placeholder">
            {qrFrameUrl ? (
              <iframe
                title={`QR code for ${user.name}`}
                src={qrFrameUrl}
                style={{ width: '100%', height: '100%', border: 'none', borderRadius: 24, background: 'white' }}
              />
            ) : (
              <div className="qr-hint">
                Upload a profile photo to generate your portrait QR.
                <br /><br />
                <span style={{ color: 'var(--brand)', fontWeight: 500 }}>
                  {publicCardUrl}
                </span>
              </div>
            )}
            <div className="qr-watermark">
              <AscendingK size={14} color="#D4CFC2" />
            </div>
          </div>

          <div className="qr-card-url">{publicCardUrl}</div>
          <div style={{ width: '100%', fontSize: 12, lineHeight: 1.5, color: 'var(--muted)', textAlign: 'center', marginTop: -4 }}>
            This QR encodes your scan page URL and uses your saved profile photo as the visual input.
          </div>

          <div className="qr-actions">
            <button className="btn btn-gold btn-full" style={{ padding: 14 }} onClick={() => qrPageUrl && window.open(qrPageUrl, '_blank')}>
              {Icons.download} Download QR Image
            </button>
            <button
              className="btn btn-outline btn-full"
              style={{ padding: 14, borderColor: 'rgba(245,242,235,0.2)', color: 'var(--paper)' }}
              disabled
            >
              Wallet Passes Coming Soon
            </button>
          </div>
        </div>

        <div style={{ maxWidth: 380, margin: '24px auto 0', textAlign: 'center' }}>
          <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>
            Your QR code will use{' '}
            <strong>
              {user.photo ? 'your profile photo' : user.logo ? 'your company logo' : 'a default pattern'}
            </strong>{' '}
            as the QR image input, and it encodes{' '}
            <strong>{publicCardUrl}</strong>
            .
          </p>
        </div>
      </div>
    </>
  );
}
